import React from 'react';
// template components
import Accordion from '@nmx/template/dist/componentLibrary/modules/Accordion';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
// icons
import MinusSignFillIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/MinusSignFill.js';
import PlusSignFillIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/PlusSignFill.js';

export default () => (
  <SectionContainer
    id='annuity-faq-request-technical-faq'
    backgroundVariant='lightA'>
    <Row align='center'>
      <Col medium={8}>
        <Typography
          component='h2'
          nextElement='typography'>
          Request Technical Support
        </Typography>
        <Accordion
          id='faq-request-technical'
          variant='secondary'
          toggleOpenIcon={PlusSignFillIcon}
          toggleCloseIcon={MinusSignFillIcon}
          isFAQ
          addFAQPageSchemaItemType={false}
          items={[
            {
              id: 'annuity-faq-request-technical-forgot-password-faq',
              title: <>What should I do if I can&#39;t remember my user id or password&#63;</>,
              contentAs: 'div',
              content: (
                <>
                  <Typography nextElement='typography'>
                    Call us toll&#45;free at <Link id='annuity-faq-toll-free-number-link' linkUrl='tel:8003888123' variant='primaryDeemphasize'>1&#45;800&#45;388&#45;8123</Link>, 7 a.m. to 6 p.m. CT, Monday through Friday.
                    Upon verifying contract information, we can give you the user id, and provide you with a new, temporary password. The next
                    time you access your policy information enter the temporary password and change it immediately to a new
                    password.
                  </Typography>
                  <Typography disableBottomPadding>
                    You can also&nbsp;
                    <Link
                      id='annuity-faq-request-technical-support-link'
                      linkUrl='https://plan.northwesternmutual.com/'
                      variant='primaryDeemphasize'>
                      reset your password online
                    </Link>.
                  </Typography>
                </>
              ),
            },
            {
              id: 'annuity-faq-request-technical-wrong-password-faq',
              title: <>What will happen if I enter the wrong password&#63;</>,
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    For security reasons, after three tries you will be locked out of your account. Please try again later. Your password is case sensitive. Enter your password exactly the way you saved it with the correct upper and lower case letters. Check to see if you have activated your&nbsp;
                    <Typography
                      component='span'
                      uppercase>
                      caps lock
                    </Typography>
                    &nbsp;key. Turn off&nbsp;
                    <Typography
                      component='span'
                      uppercase>
                      caps lock
                    </Typography>
                    &nbsp;and enter your password again.
                  </Typography>
                </>
              ),
            },
            {
              id: 'annuity-faq-request-technical-clear-incorrect-login-info-faq',
              title: <>How do I clear incorrect login information from the system&#63;</>,
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    Your browser may have cached &#40;stored on your hard drive&#41; the incorrect information and is not sending your new information to the server. Close your browser and disconnect from your Internet Service Provider. Wait about ten seconds and reconnect to the Internet. Open your browser and go back to the site.
                    Reenter your login information.
                  </Typography>
                </>
              ),
            },
            {
              id: 'annuity-faq-request-technical-why-error-messages-faq',
              title: <>Why do I get these error messages&#63;</>,
              contentAs: 'div',
              content: (
                <>
                  <Typography nextElement='typography'>
                    <strong>&#34;We are unable to display your policy values at this time.&#34;</strong>
                  </Typography>
                  <Typography nextElement='typography'>
                    Customers who come to our site from a bookmark will sometimes get this message. A connection has failed in relation to the bookmark. Enter in the address field of your browser the URL for our site
                    instead of using the bookmark.
                  </Typography>
                  <Typography nextElement='typography'>
                    <strong>&#34;We are unable to provide you with contract information.&#34;</strong>
                  </Typography>
                  <Typography disableBottomPadding>
                    This message displays when someone other than the owner of a policy attempts to view policy information. If you are the payer or the insured of a policy but not the owner, you will not be given access
                    to the policy information.
                  </Typography>
                </>
              ),
            },
            {
              id: 'annuity-faq-request-technical-no-statements-after-login-faq',
              title: <>Why can&#39;t I view my policy statements after I&#39;ve logged in&#63;</>,
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    To view policy statements, you will need the free Adobe Acrobat Reader&#174;. Adobe, the Adobe logo and Acrobat are trademarks of Adobe Systems Incorporated.
                  </Typography>
                </>
              ),
            },
            {
              id: 'annuity-faq-request-technical-how-to-see-values-faq',
              title: <>What can I do to see all of my values when I print my statement&#63;</>,
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    If you print your statement and the right&#45;hand side of the page has missing values, there is a simple change you can make to your system to resolve this. Within your operating system, select a display setting of at least 800 &#215; 600 pixels. Browse to your statement and select File and Print within your browser&#39;s menu at the top of the page. Next, change the print orientation to Landscape and your statement will print correctly.
                  </Typography>
                </>
              ),
            },
          ]}
        />
      </Col>
    </Row>
  </SectionContainer>
);
